<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_PAYMENT_DUE_DATE_CHANGE_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row" *ngIf="!isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <p class="page-subtitle">{{ 'COMMON_LBL_ERROR_MSG_NO_ACTIVE_LEASE' | translate }}</p>
            <p></p>
        </section>
        <section class="col-sm-2"></section>
    </div>
    <div class="row" *ngIf="isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <div class="region region-content">
                <form class="custom-from" #customForm="ngForm" (ngSubmit)="submitForm(customForm)" novalidate>
                    <p class="subtitle">{{ 'REQUEST_PAYMENT_DUE_DATE_CHANGE_TITLE' | translate }}</p>
                    <p></p>
                    <div>{{ 'REQUEST_PAYMENT_DUE_DATE_CHANGE_NEXT_PAYMENT_DATE' | translate }} {{ paymentDateChangeViewModel.nextPaymentDate | date:'yyyy/MM/dd' }}</div>
                    <div *ngIf="showPaymentDayOfWeek">{{ 'REQUEST_PAYMENT_DUE_DATE_CHANGE_CURRENT_PAYMENT_DAY' | translate }} {{ paymentDayOfWeek }}</div>
                    <p></p>
                    <p>{{ 'REQUEST_PAYMENT_DUE_DATE_CHANGE_VALID_NEW_DATES' | translate }}</p>
                    <div *ngIf="validNewPaymentDateSelection">
                        <div style="margin-left: 15px; margin-bottom: 10px;" *ngFor="let validDate of validNewPaymentDateSelection; let i = index">
                            <input type="radio" name="newPaymentDate" [value]="validDate.value" [(ngModel)]="newPaymentDate" required> 
                                {{ validDate.display }}
                        </div>
                    </div>
                    <a href="javascript:" style="margin-left: 15px; text-decoration: none;" *ngIf="showLoanMore" (click)="handleLoadMore()">----------- {{ 'REQUEST_PAYMENT_DUE_DATE_CHANGE_LOAD_MORE' | translate }} -----------</a>
                    <div *ngIf="formSubmitted && customForm.invalid" class="row" style="margin: auto;">
                        <div class="col-sm-12 error-note">
                            <label translate="REQUEST_PAYMENT_DUE_DATE_CHANGE_ERROR"></label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-secondary action-row" [disabled]="!newPaymentDate">{{ 'COMMON_BTN_SUBMIT' | translate }}</button>
                        </div>
                    </div>
                    <p>{{ 'REQUEST_PAYMENT_DUE_DATE_CHANGE_NOTE1' | translate }}</p>
                    <p></p>
                    <p>{{ 'REQUEST_PAYMENT_DUE_DATE_CHANGE_NOTE2' | translate }}</p>
                </form>
            </div>
        </section>
        <section class="col-sm-2"></section>
    </div>
</div>